var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-left",attrs:{"cols":"12"}},[_c('MessageSheet',{attrs:{"type":"success","title":"Verification link sent"}},[_c('p',[_vm._v(" We have just sent you an e-mail with a verification link. ")]),_c('p',[_vm._v("The link is valid for 24 hours.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }